export default function DateText({children}) {
    return <span className="text-datesub text-xs">{children}</span>;
}